var _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.32,173.44C89.68,116,151.1,119.3,188.2,128.76c46.18,11.79,79.87,25,127.72,14.54,38.26-8.37,81.89-26.77,112.8,10,25.33,30.15,13.79,71.25-12.51,96.73-23.39,22.66-58.08,27.79-81,51.74-14.72,15.34-26.75,33.64-44.27,46.1-18.94,13.46-44,13.37-65.18,4.33-36.84-15.72-45.38-54.26-65.82-84.72C140.1,238,97.37,211.07,94.32,173.44Z",
    style: {
      fill: "#2143FD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.32,173.44C89.68,116,151.1,119.3,188.2,128.76c46.18,11.79,79.87,25,127.72,14.54,38.26-8.37,81.89-26.77,112.8,10,25.33,30.15,13.79,71.25-12.51,96.73-23.39,22.66-58.08,27.79-81,51.74-14.72,15.34-26.75,33.64-44.27,46.1-18.94,13.46-44,13.37-65.18,4.33-36.84-15.72-45.38-54.26-65.82-84.72C140.1,238,97.37,211.07,94.32,173.44Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-103"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-103",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Starman--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.25,199.43c1.44.44,5.82-1.37,7.47-3.1s-2.06-7.87-4.82-6.74C263.2,191.09,261.71,198.65,264.25,199.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.53,222.51l-.44,1-.42.87-.89,1.7c-.6,1.12-1.24,2.22-1.9,3.31a64.45,64.45,0,0,1-4.43,6.37,44.15,44.15,0,0,1-5.67,6A28.08,28.08,0,0,1,244,244.5a26.28,26.28,0,0,1-4.29,2.07A33.7,33.7,0,0,1,223,247.86a49,49,0,0,1-7.54-1.78c-1.21-.4-2.41-.82-3.59-1.3-.58-.24-1.17-.49-1.75-.76s-1.12-.53-1.79-.87l2.46-6.75,1.56.21,1.64.2c1.1.12,2.19.24,3.29.3a55.39,55.39,0,0,0,6.42.13,35.44,35.44,0,0,0,6-.72,26.2,26.2,0,0,0,2.68-.73,17.35,17.35,0,0,0,2.35-1,11.33,11.33,0,0,0,3.65-2.92,40.69,40.69,0,0,0,3.56-4.61c1.15-1.71,2.28-3.53,3.35-5.39.56-.92,1.08-1.87,1.61-2.81h0a2.11,2.11,0,0,1,2.65-1.05Z",
    style: {
      fill: "#2143FD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.53,222.51l-.44,1-.42.87-.89,1.7c-.6,1.12-1.24,2.22-1.9,3.31a64.45,64.45,0,0,1-4.43,6.37,44.15,44.15,0,0,1-5.67,6A28.08,28.08,0,0,1,244,244.5a26.28,26.28,0,0,1-4.29,2.07A33.7,33.7,0,0,1,223,247.86a49,49,0,0,1-7.54-1.78c-1.21-.4-2.41-.82-3.59-1.3-.58-.24-1.17-.49-1.75-.76s-1.12-.53-1.79-.87l2.46-6.75,1.56.21,1.64.2c1.1.12,2.19.24,3.29.3a55.39,55.39,0,0,0,6.42.13,35.44,35.44,0,0,0,6-.72,26.2,26.2,0,0,0,2.68-.73,17.35,17.35,0,0,0,2.35-1,11.33,11.33,0,0,0,3.65-2.92,40.69,40.69,0,0,0,3.56-4.61c1.15-1.71,2.28-3.53,3.35-5.39.56-.92,1.08-1.87,1.61-2.81h0a2.11,2.11,0,0,1,2.65-1.05Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.24,232.39A51.51,51.51,0,0,0,234.05,248a29.1,29.1,0,0,0,5.69-1.43A25.71,25.71,0,0,0,244,244.5a28.08,28.08,0,0,0,3.76-2.75,44.68,44.68,0,0,0,5.67-6c.6-.76,1.18-1.52,1.73-2.3C251.74,231.66,246.84,229.88,244.24,232.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.1,218.69c-3.7,6-10.09,19.22-11.94,41.15l31.72,10.05c1.48-4,4.41-23.11,14.06-41a3.86,3.86,0,0,0-1.45-5.2,43.14,43.14,0,0,0-6.62-3.16,139.33,139.33,0,0,0-13.48-4.28c-1.79-.41-3.57-.72-5.11-.94A7.22,7.22,0,0,0,247.1,218.69Z",
    style: {
      fill: "#2143FD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.1,218.69c-3.7,6-10.09,19.22-11.94,41.15l31.72,10.05c1.48-4,4.41-23.11,14.06-41a3.86,3.86,0,0,0-1.45-5.2,43.14,43.14,0,0,0-6.62-3.16,139.33,139.33,0,0,0-13.48-4.28c-1.79-.41-3.57-.72-5.11-.94A7.22,7.22,0,0,0,247.1,218.69Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.36,241.68l-.91-9.31a1,1,0,0,1,.33-.87l7.72-7.1a1,1,0,0,1,1.74.66l.91,9.32a1.06,1.06,0,0,1-.33.87l-7.72,7.1A1,1,0,0,1,249.36,241.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.9,233.25c-1.15,2.41-1.11,8.2-.15,12.16.93-2.66,2-5.42,3.19-8.2Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.1,206.24c-2,3.58-4.92,10.34-3.06,13.74,0,0-1.73,2.26-7.54.2-4.13-1.47-4.33-4-4.33-4,4.58.34,5.47-2.86,5.67-6.06Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.33,207.84l-5.48,2.31a13.34,13.34,0,0,1-.3,2.22c1.7.28,4.5-.79,5.21-2.44A6,6,0,0,0,270.33,207.84Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.4,201.75c-2.53,4.81-3.77,7.75-7.41,9.17-5.47,2.12-10.56-2.89-9.52-8.36.94-4.92,4.92-12,10.65-11.75A7.42,7.42,0,0,1,277.4,201.75Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.66,204.61c-.79-1.27-.16-6,1.1-8s8.13,0,7.75,3C283,203.51,276.07,206.87,274.66,204.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.85,196.49c-11-2.91-7.21-8.51-11.41-8.29s-2.63,2.47-2.63,2.47-3.84-2.27,1.34-4.14,3.39.3,6.57.6c3.46.33,7-2.1,8.3,1.07s1.87,5.29,3.79,5.67c3.53.7,1,8-1.81,5.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.47,206.73a4.3,4.3,0,0,1-3.11,1.1c-1.51-.09-1.77-1.56-.94-2.73s2.43-2.27,3.75-1.6A1.93,1.93,0,0,1,277.47,206.73Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.27,199.76c-.18.4-.54.63-.8.51s-.33-.54-.15-.94.54-.64.81-.52S269.46,199.35,269.27,199.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.72,197.71c-.18.4-.54.63-.8.51s-.33-.54-.15-.94.54-.64.8-.52S264.9,197.3,264.72,197.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.08,198.56a15.89,15.89,0,0,1-3.47,2.58,2.54,2.54,0,0,0,1.76,1.22Z",
    style: {
      fill: "#ed847e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.38,204.3A3.79,3.79,0,0,1,265,204a.13.13,0,0,1-.07-.17.14.14,0,0,1,.18-.06,3.5,3.5,0,0,0,3.16-.08.13.13,0,0,1,.14.22A3.19,3.19,0,0,1,267.38,204.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.46,198.92a.26.26,0,0,1-.3-.19,2.11,2.11,0,0,0-1.16-1.48.25.25,0,0,1-.15-.33.26.26,0,0,1,.33-.15,2.56,2.56,0,0,1,1.49,1.84.26.26,0,0,1-.2.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.59,195.26a.26.26,0,0,1-.25-.08.27.27,0,0,1,0-.37,2.6,2.6,0,0,1,2.3-.57.26.26,0,0,1-.15.5,2.06,2.06,0,0,0-1.81.47A.21.21,0,0,1,263.59,195.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.89,
    cy: 203.24,
    r: 19.69,
    transform: "translate(-66.5 171.77) rotate(-31.64)",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.21,184.11,272,222.82a19,19,0,0,0,3.92-.83l-6.71-38.43A18.69,18.69,0,0,0,265.21,184.11Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.75,183.56l6.61,37.9a19.84,19.84,0,0,0,2-1,18.66,18.66,0,0,0,3.46-2.43l-5.8-33.17A19.7,19.7,0,0,0,270.75,183.56Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.66,209.51a20.73,20.73,0,0,1-38.16,3.3,1.46,1.46,0,0,1,1.92-2l.22.1c12.75,5.7,26.77,5.7,31.33,0s-2.09-14.91-14.83-20.6a50.89,50.89,0,0,0-9-3.05,1.46,1.46,0,0,1-.27-2.75,20.73,20.73,0,0,1,28.77,24.95Z",
    style: {
      fill: "#2143FD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.66,209.51a20.73,20.73,0,0,1-38.16,3.3,1.46,1.46,0,0,1,1.92-2l.22.1c12.75,5.7,26.77,5.7,31.33,0s-2.09-14.91-14.83-20.6a50.89,50.89,0,0,0-9-3.05,1.46,1.46,0,0,1-.27-2.75,20.73,20.73,0,0,1,28.77,24.95Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.91,224.7a21.46,21.46,0,0,1-15.46-6.55.73.73,0,0,1,0-1,.72.72,0,0,1,1,0,20.09,20.09,0,0,0,18.87,5.61.72.72,0,0,1,.33,1.41A21.43,21.43,0,0,1,269.91,224.7Z",
    style: {
      fill: "#263238",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.29,272.09c-21.05-4-33.76-10.75-34.29-11l2.05-3.84c.12.07,12.71,6.68,33.07,10.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.15,245.18l3.25-8.83s-11.08-5-13.85-.95S202.06,242.08,211.15,245.18Z",
    style: {
      fill: "#2143FD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.15,245.18l3.25-8.83s-11.08-5-13.85-.95S202.06,242.08,211.15,245.18Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.72,236.37l4.28.85s-2.32-7.56-4.19-7.3S208,232.48,209.72,236.37Z",
    style: {
      fill: "#2143FD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.72,236.37l4.28.85s-2.32-7.56-4.19-7.3S208,232.48,209.72,236.37Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.2,260.48A.4.4,0,0,1,266,260a.36.36,0,1,1,.67.19A.42.42,0,0,1,266.2,260.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.68,262.31a.4.4,0,0,1-.21-.53.41.41,0,0,1,.46-.34.41.41,0,0,1,.21.53A.42.42,0,0,1,265.68,262.31Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.16,264.14a.46.46,0,0,1,.24-.87.46.46,0,0,1-.24.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.93,261.68a.41.41,0,0,1-.21-.53.4.4,0,0,1,.46-.34.41.41,0,0,1,.21.53A.42.42,0,0,1,266.93,261.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.41,263.5a.42.42,0,0,1-.22-.53c.07-.24.28-.39.46-.33a.42.42,0,0,1,.22.53C266.8,263.41,266.59,263.56,266.41,263.5Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.89,265.33a.42.42,0,0,1-.22-.53c.07-.24.28-.39.46-.33a.4.4,0,0,1,.21.53C266.28,265.23,266.07,265.39,265.89,265.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,236.11l-.91-.15a4.71,4.71,0,0,1-1.42-.5h0a.82.82,0,0,0-1.16.39l-3.4,8.15a.82.82,0,0,0,.34,1l1.19.72a5.1,5.1,0,0,0,.92.42l2.11.67a.81.81,0,0,0,1-.61l2-9.12A.83.83,0,0,0,216,236.11Z",
    style: {
      fill: "#263238"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "427.43 269.49 119.91 225.35 91.47 243.85 87.3 272.87 420.08 320.64 427.43 269.49"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "427.43 269.49 119.91 225.35 91.47 243.85 87.3 272.87 420.08 320.64 427.43 269.49",
    style: {
      fill: "#2143FD",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.61,219.91c8.24-6,37.33-27.92,45.19-26.8l3.6.52c1.41.2-1.89,1.31-7.56,5.47-7.12,5.23-27.77,21.13-30.46,26.12C187.84,224,185.61,219.91,185.61,219.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.77,219.8c14.7-.56,19.32-.69,21.89,2.49s2.84,11.52,2.84,11.52l-26-9.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.36,233.65c-18.06-10.83-23.9-14.4-29.26-11.55-9.78,5.19-3.1,17.47-3.1,17.47l30.79,1.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.14,237.23h0a1.57,1.57,0,0,1-1.87-1.16l-4.81-20.67a1.56,1.56,0,0,1,1.16-1.87h0a1.57,1.57,0,0,1,1.87,1.16l4.81,20.67A1.55,1.55,0,0,1,224.14,237.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.55,272.18c-4.24,6.13-5.82,28.79-10,36.95s-7,16.05-25.49,13.4h0a1.26,1.26,0,0,1-.84-2,33.41,33.41,0,1,0-58.65-8.41,1.27,1.27,0,0,1-1.37,1.67L158.75,286.6a1.25,1.25,0,0,1-.84-2,33.41,33.41,0,1,0-58.65-8.42,1.26,1.26,0,0,1-1.36,1.67l-11-1.57a14.18,14.18,0,0,1-2-.46l-14-4.36a13.09,13.09,0,0,1-8.79-9.24c-2.06-8-3.62-20.36,4.66-24.77,51.6-27.44,97.47-23.72,130.65-17.16,51.09,19.46,120.38,22.33,128.38,1.81,24.64,3.54,101.94,35.85,111.79,37.61S448.8,266.05,444.55,272.18Z",
    style: {
      fill: "#2143FD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.75,222.77c23.71-5.61,59.13.39,78.42,11.17C205.75,233.8,161.91,223.68,133.75,222.77Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.74,233.45a20.31,20.31,0,0,1-7.08,4.23,1.15,1.15,0,0,0,.3,2.24c12.79,1.58,38.8,4.37,56.69,4.66a1.45,1.45,0,1,0,.27-2.88c-18.65-3.12-44.52-7.76-49.05-8.57A1.28,1.28,0,0,0,322.74,233.45Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.78,
    cy: 265.11,
    r: 27.5,
    transform: "translate(-164.71 273.74) rotate(-65.41)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.06,
    cy: 301.04,
    r: 27.5,
    transform: "translate(-51.23 522.31) rotate(-65.41)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.78,
    cy: 265.11,
    r: 22.5,
    transform: "translate(-83.72 61.7) rotate(-20.26)",
    style: {
      fill: "#2143FD",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.3,263.5l-12.91-.3a3.29,3.29,0,0,1-2.47-5.38L148,248l-1-1.34-9.34,8.92a3.3,3.3,0,0,1-5.56-2.06l-1.27-12.66-1.65-.24-.3,12.91a3.29,3.29,0,0,1-5.38,2.47l-9.85-8.05-1.33,1,8.91,9.34a3.29,3.29,0,0,1-2,5.55l-12.66,1.27-.24,1.65,12.91.3a3.29,3.29,0,0,1,2.47,5.38l-8,9.85,1,1.33,9.34-8.91a3.3,3.3,0,0,1,5.56,2.06l1.27,12.66,1.65.23.3-12.9a3.29,3.29,0,0,1,5.38-2.48l9.85,8.06,1.33-1L140.35,272a3.3,3.3,0,0,1,2.05-5.56l12.66-1.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.65,265.81a4.92,4.92,0,1,1-4.17-5.57A4.92,4.92,0,0,1,135.65,265.81Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.06,
    cy: 301.04,
    r: 22.5,
    transform: "translate(-87.76 174.39) rotate(-23.19)",
    style: {
      fill: "#2143FD",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.58,299.42l-12.9-.3a3.29,3.29,0,0,1-2.48-5.38l8.06-9.85-1-1.33-9.34,8.91a3.29,3.29,0,0,1-5.55-2.05l-1.27-12.66-1.65-.24-.3,12.91a3.29,3.29,0,0,1-5.38,2.47l-9.85-8-1.34,1,8.92,9.34a3.3,3.3,0,0,1-2.06,5.56L356.78,301l-.24,1.65,12.91.3a3.3,3.3,0,0,1,2.48,5.38l-8.06,9.85,1,1.33,9.34-8.91a3.29,3.29,0,0,1,5.55,2.05L381,325.32l1.65.24.3-12.91a3.29,3.29,0,0,1,5.38-2.47l9.85,8.06,1.34-1-8.92-9.34a3.3,3.3,0,0,1,2.06-5.56l12.66-1.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.94,301.74a4.93,4.93,0,1,1-4.18-5.57A4.92,4.92,0,0,1,385.94,301.74Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,219.85q-4.56,1-9.23,2.31a178.19,178.19,0,0,0-18.2,6.15q-6.49,2.56-13.14,5.79c8.13,1.94,25.09-1.39,33.46-3.89C114.33,228,114.26,222,114,219.85Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.37,300.73h-.07L181,284.47a.51.51,0,0,1-.43-.48c0-.33-.68-33.37,17.69-58.74a.5.5,0,1,1,.81.59c-17.05,23.55-17.52,53.79-17.5,57.7l112.63,16.17c14.11-12.33,37.82-51.24,36.81-54-2-2.4,1.57-13.48,2-14.74a.5.5,0,0,1,.95.32c-1.5,4.54-3.41,12.3-2.14,13.82,2.47,3-24.13,44.33-37.12,55.54A.5.5,0,0,1,294.37,300.73Z",
    style: {
      fill: "#263238",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.6,223.62l-7.45.52a3.73,3.73,0,0,1-4-3.63l0-1.57a3.73,3.73,0,0,1,4.17-3.8l7.49.88a3.83,3.83,0,0,1,3.38,3.8h0A3.83,3.83,0,0,1,210.6,223.62Z",
    style: {
      fill: "#2143FD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.73,250.62a53.3,53.3,0,0,0,8.91,1.86c1.71.16,3.31,2,3.72,4.28s1,5.15,1.44,7.53c.57,2.83-.91,5.15-3.07,4.82-3.52-.53-8.34-1.59-10.48-3.55a2.66,2.66,0,0,1-.8-2.08,32.41,32.41,0,0,0-1.15-10.55C66.89,251.54,67.65,250.31,68.73,250.62Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.93,281.74a17.6,17.6,0,0,0,4.94,1.53c1.09-5,2.3-9.26,3.85-11.32h0a50.13,50.13,0,0,0-9.09,3.9A3.33,3.33,0,0,0,435.93,281.74Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.35,224.69l.49.46.57.7,1.07,1.42c.68,1,1.36,1.92,2,2.91s1.25,2,1.84,3,1.14,2.08,1.69,3.15a52.44,52.44,0,0,1,2.83,6.76c.2.59.38,1.2.55,1.82l.27.92.06.24.08.33.16.66a19.5,19.5,0,0,1,.41,4.72,34.06,34.06,0,0,1-1.25,7.67,57.51,57.51,0,0,1-2.3,6.71c-.87,2.14-1.86,4.2-2.9,6.21a67.31,67.31,0,0,1-3.46,5.91l-6.52-3c1-4,2-8.18,2.8-12.16.36-2,.71-4,.88-5.89.1-1,.15-1.87.19-2.76a19.05,19.05,0,0,0-.09-2.45,7.27,7.27,0,0,0-.39-1.71l-.05-.13,0-.06-.07-.15-.28-.61c-.18-.4-.36-.81-.59-1.22-.81-1.63-1.74-3.29-2.77-4.94-.51-.82-1-1.65-1.58-2.46s-1.08-1.65-1.65-2.46-1.13-1.63-1.7-2.43l-1.65-2.3Z",
    style: {
      fill: "#2143FD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.35,224.69l.49.46.57.7,1.07,1.42c.68,1,1.36,1.92,2,2.91s1.25,2,1.84,3,1.14,2.08,1.69,3.15a52.44,52.44,0,0,1,2.83,6.76c.2.59.38,1.2.55,1.82l.27.92.06.24.08.33.16.66a19.5,19.5,0,0,1,.41,4.72,34.06,34.06,0,0,1-1.25,7.67,57.51,57.51,0,0,1-2.3,6.71c-.87,2.14-1.86,4.2-2.9,6.21a67.31,67.31,0,0,1-3.46,5.91l-6.52-3c1-4,2-8.18,2.8-12.16.36-2,.71-4,.88-5.89.1-1,.15-1.87.19-2.76a19.05,19.05,0,0,0-.09-2.45,7.27,7.27,0,0,0-.39-1.71l-.05-.13,0-.06-.07-.15-.28-.61c-.18-.4-.36-.81-.59-1.22-.81-1.63-1.74-3.29-2.77-4.94-.51-.82-1-1.65-1.58-2.46s-1.08-1.65-1.65-2.46-1.13-1.63-1.7-2.43l-1.65-2.3Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.26,274.55l-8.53-4s-5.86,10.63-2.08,13.73S281.42,283.37,285.26,274.55Z",
    style: {
      fill: "#2143FD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.26,274.55l-8.53-4s-5.86,10.63-2.08,13.73S281.42,283.37,285.26,274.55Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.74,275l.83-4.29s-7.56,2.37-7.28,4.24S272.86,276.78,276.74,275Z",
    style: {
      fill: "#2143FD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.74,275l.83-4.29s-7.56,2.37-7.28,4.24S272.86,276.78,276.74,275Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.07,268.06l-.22.9a4.38,4.38,0,0,1-.61,1.38h0a.81.81,0,0,0,.31,1.18l7.85,4a.81.81,0,0,0,1-.25l.81-1.14a4,4,0,0,0,.48-.89l.84-2a.81.81,0,0,0-.53-1.09l-8.94-2.65A.82.82,0,0,0,277.07,268.06Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.5bc8255905a4ce0413593434c99ef30d.svg";
export { ForwardRef as ReactComponent };